module.exports = __webpack_public_path__ + "fonts/Mulish-Black.797c7eb.woff";